import { jsx as _jsx } from "react/jsx-runtime";
import { Flex, Loader } from "@mantine/core";
export const PageLoadIndicator = () => {
    return (_jsx(Flex, { style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "75vh"
        }, children: _jsx(Loader, { size: "lg" }) }));
};
